// entzy models and services
import configEntzy from "components/config/ConfigEntzy";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff as iconActiveSwitch } from "@fortawesome/pro-duotone-svg-icons";
import { faDoNotEnter as iconPrivateSwitch } from "@fortawesome/pro-duotone-svg-icons";
import { faDotCircle as iconFallback } from "@fortawesome/pro-duotone-svg-icons";
import { faStopwatch as iconTimeMin } from "@fortawesome/pro-duotone-svg-icons";
import { faUserGroup as iconUserMin } from "@fortawesome/pro-duotone-svg-icons";
import { faUserCircle as iconUserGroup } from "@fortawesome/pro-duotone-svg-icons";
import { faUsersLine as iconUserMax } from "@fortawesome/pro-duotone-svg-icons";
import { faQrcode as iconTicketText } from "@fortawesome/pro-duotone-svg-icons";
import { faStopwatch as iconAge } from "@fortawesome/pro-regular-svg-icons";

// extended dayjs for utc
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(customParseFormat);

// icon getters
export const getAdormentIcon = function (icon) {
  let iconValue;
  switch (icon) {
    case "active-switch":
      iconValue = iconActiveSwitch;
      break;
    case "private-switch":
      iconValue = iconPrivateSwitch;
      break;
    case "ticket-text":
      iconValue = iconTicketText;
      break;
    case "time-min":
      iconValue = iconTimeMin;
      break;
    case "user-min":
      iconValue = iconUserMin;
      break;
    case "user-group":
      iconValue = iconUserGroup;
      break;
    case "user-max":
      iconValue = iconUserMax;
      break;
    default:
      iconValue = iconFallback;
      break;
  }
  return <FontAwesomeIcon icon={iconValue} fixedWidth />;
};

// id generators
// javascript guid generator
// for use client side only until replaced server side
export const idGenerator = (len) => {
  const S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  const ID =
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4();
  return len ? ID.substring(0, len) : ID;
};
export const idTimeGenerator = (params = {}) => {
  const ts = params.micro ? Date.now() : Math.floor(Date.now() / 1000);
  const rd = Math.floor(Math.random() * 100);
  const id = params.addRandom ? `${ts}${rd}` : `${ts}`;
  return id;
};
export const getTemporaryGuid = function () {
  let timestamp, random, tmpGuid;
  timestamp = "tmp" + Date.now();
  random = Math.random().toString(36);
  tmpGuid = "";
  tmpGuid += timestamp.substring(0, 3);
  tmpGuid += timestamp.substring(9, 12);
  tmpGuid += random.substring(10, 12) + "-";
  tmpGuid += timestamp.substring(12, 16) + "-";
  tmpGuid += random.substring(2, 6) + "-";
  tmpGuid += random.substring(6, 10);
  return tmpGuid;
};
export const getCombinedUserId = function (userId1, userId2) {
  const delimiter = configEntzy.DELIMITER_USERS;
  const sortedStrings = [userId1, userId2].sort();
  const combinedString = sortedStrings[0] + delimiter + sortedStrings[1];
  return combinedString;
};
export const getDefaultLargeInt = function () {
  return 100000000;
};

// dynamodb ttl generator
export const getDynamoDBTTL = function (days) {
  const currentTime = new Date().getTime();
  const oneDay = 24 * 60 * 60 * 1000; // one day in milliseconds
  const expirationTime = currentTime + days * oneDay;
  return Math.floor(expirationTime / 1000); // TTL requires the timestamp to be in seconds
};

// age generator
export const getAge = (props) => {
  let ageValue = "";
  try {
    const currentTimestamp = dayjs.utc();
    const utcTimestamp = props.timestamp;
    const format = "YYYY-MM-DDTHH:mm:sssZ";
    const timestampObj = props.timestampObj
      ? props.timestampObj
      : dayjs.utc(utcTimestamp, format);
    const diffInMins = currentTimestamp.diff(timestampObj, "minute");
    const diffInHours = currentTimestamp.diff(timestampObj, "hour");
    const diffInDays = currentTimestamp.diff(timestampObj, "day");
    // const diffInWeeks = currentTimestamp.diff(timestampObj, "week");
    // const diffInMonths = currentTimestamp.diff(timestampObj, "month");
    const diffInYears = currentTimestamp.diff(timestampObj, "year");

    if (diffInMins < 60) {
      if (diffInMins <= 0) {
        ageValue = "now";
      } else {
        ageValue = `${diffInMins}m`;
      }
    } else if (diffInHours < 24) {
      ageValue = `${diffInHours}h`;
    } else if (diffInDays > 365) {
      ageValue = `${diffInYears}y`;
      // } else if (diffInWeeks < 4) {
      //   ageValue = `${diffInWeeks}wk`;
      // } else if (diffInMonths < 12) {
      //   ageValue = `${diffInMonths}mo`;
    } else {
      ageValue = `${diffInDays}d`;
    }
  } catch (error) {
    ageValue = "earlier";
  }
  return (
    <span>
      <FontAwesomeIcon icon={iconAge} />
      &nbsp;&nbsp;
      {ageValue}
    </span>
  );
};
